import script from "./BenefitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitsView.vue?vue&type=script&setup=true&lang=js"

import "./BenefitsView.vue?vue&type=style&index=0&id=73b4cce2&lang=scss"

const __exports__ = script;

export default __exports__